import { useQuery } from "react-query";
import { fetchWorkspaceCustomFields } from "@/services/custom-fields";
/** Query hook for all custom field definitions in a workspace. */
export function useWorkspaceCustomFields(workspaceId) {
  var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return useQuery(["workspace-custom-fields", workspaceId], function () {
    return fetchWorkspaceCustomFields(workspaceId);
  }, {
    enabled: Boolean(workspaceId) && enabled
  });
}